import { ShippingOrdersSagaWatcher } from './ExportLists/services/saga';

export const documentModuleSaga = [ShippingOrdersSagaWatcher];
